<div class="row" style="max-width: 80%; margin: 0 auto; text-align: center;">
    <div class="col-sm-12">
        <div >
            <h1 class="page-label">Portal Validation - Dashboard</h1>
            <h4 class="page-label" style="color: white;">Selected Portal: {{ portal?.name }}</h4>
        </div>
        <div style="padding-top:20px;">
            <h3 class="page-label" style="padding-bottom: 10px;">Status: {{ getDisplayState(currentState.state) }}</h3>
            <h4 *ngIf="currentState?.attempt" class="page-label" style="text-align: start;">Carton Id: {{ currentState?.attempt?.carton_id }}</h4>
        </div>
    </div>
</div>

<div *ngIf="isDisplayState_EnterInfo()" class="row" style="max-width: 80%; margin: 0 auto; text-align: center;">
    <label class="col-sm-3 input-label" for="portal-input">Carton ID:</label>
    <div class="printer-input col-sm-9">
        <div class="row">
            <input #cartonIdField class="form-control" type="text" [(ngModel)]="cartonId" (keydown.enter)="enterCartonId()" autofocus />
        </div>
    </div>
</div>


<ng-container *ngIf="currentState?.attempt">
    <table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table" role="grid" style="max-width: 80%; margin-left: auto; margin-right: auto;">
        <thead>
            <tr role="row" class="tablesorter-headerRow">
                <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                    <div class="tablesorter-header-inner">ITEM</div>
                </th>
                <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                    <div class="tablesorter-header-inner">UPC</div>
                </th>
                <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                    <div class="tablesorter-header-inner"># REQUIRED</div>
                </th>
                <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                    <div class="tablesorter-header-inner"># READ</div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr role="row" *ngFor="let lineItem of currentState.attempt?.line_items; index as i;" [class.green-highlight]="isSuccessRow(lineItem)" [class.red-highlight]="isErrorRow(lineItem)" [class.yellow-highlight]="isPartialRow(lineItem)" [class.gray-highlight]="isUnknownRow(lineItem)">
                <td>
                    {{ lineItem?.item }}
                </td>
                <td>
                    {{ lineItem?.upc }}
                </td>
                <td>
                    {{ lineItem?.required_quantity }}
                </td>
                <td>
                    {{ lineItem?.scanned_quantity }}
                </td>
            </tr>
        </tbody>
    </table>

    <div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
        <div class="col-sm-3">
            &nbsp;
        </div>
        <div class="col-sm-6">
        </div>
        <div class="col-sm-3">
            <button class="submit btn btn-primary" (click)="onClearCartonClicked()" [disabled]="isProcessingAction">Clear Carton</button>
            &nbsp;
            <button class="submit btn btn-primary" (click)="onProcessCartonClicked()" [disabled]="isProcessingAction">Process Carton</button>
        </div>
    </div>
</ng-container>



<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog>
</ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
